// src/components/PageHelmet.jsx
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const PageHelmet = () => {
  const baseTitle = "ООО Премексбел | Счетчики воды и тепла | Минск (РБ) ";
  const location = useLocation();
  
  // Соответствие путей и заголовков
  const titles = {
    '/': `Главная - ${baseTitle}`,
    '/contact': `Контакты - ${baseTitle}`,
    '/technology/Lora': `LoRaWAN - Технологии - ${baseTitle}`,
    '/technology/NB-Iot': `NB-IoT - Технологии - ${baseTitle}`,
    '/technology/IoT': `IoT - Технологии - ${baseTitle}`,
    '/technology/M-Bus': `M-Bus - Технологии - ${baseTitle}`,
    '/technology/RS-485': `RS-485 - Технологии - ${baseTitle}`,
    '/documents': `Документация - ${baseTitle}`,
    '/sitemap': `Карта сайта - ${baseTitle}`,
    '/about': `О компании - ${baseTitle}`,
    '/catalog': `Каталог продукции - ${baseTitle}`,
    '/technologes': `Технологии - ${baseTitle}`,
  };
    
    
  // Универсальное описание
  const description = "Производство и продажа счетчиков воды и тепла в Беларуси. Установка, поверка, дистанционный съем данных. Цены от производителя.";

  return (
    <Helmet>
      <title>{titles[location.pathname] || baseTitle}</title>
      <meta name="description" content={description} />
    </Helmet>
  );
};

export default PageHelmet;